import { render, staticRenderFns } from "./ShopHeaderPreview.vue?vue&type=template&id=5df8d933&scoped=true&"
import script from "./ShopHeaderPreview.vue?vue&type=script&lang=js&"
export * from "./ShopHeaderPreview.vue?vue&type=script&lang=js&"
import style0 from "./ShopHeaderPreview.vue?vue&type=style&index=0&id=5df8d933&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8d933",
  null
  
)

export default component.exports